import flatpickr from 'flatpickr';

import * as M from 'shared/types/models';

export function getFormattedRangeDate(date?: M.DateRange | null) {
  if (!date) {
    return '';
  }

  const startDate = new Date(date.start);
  const endDate = new Date(date.end);

  return `${flatpickr.formatDate(startDate, 'd/m/y')} - ${flatpickr.formatDate(endDate, 'd/m/y')}`;
}
